import { render, staticRenderFns } from "./LabelQuestion.vue?vue&type=template&id=97f29350&"
import script from "./LabelQuestion.vue?vue&type=script&lang=js&"
export * from "./LabelQuestion.vue?vue&type=script&lang=js&"
import style0 from "./LabelQuestion.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports